<div class="row">
  <div class="col-8 mt-4 p-4">
      <div class="alert alert-info p-5">
        {{ 'no_products_landing_page' | translate }}
      </div>
  </div>
</div>
